module.exports = __webpack_public_path__ + "static/media/Getty_Images_1145406500_tablet.4ca7a2df.jpg";